import { RatingSummaryQueryInterface, RecipeReviewInterface } from "../../../app/recipePage/recipePage.types";

const timestampRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

export const sanitizeReviewsData = (reviews: RecipeReviewInterface[]) => {
  const sanitizedReviews = reviews.filter((review) => (
    review?.rating !== null && review?.rating !== undefined &&
    review?.startTime && timestampRegex.test(review?.startTime) &&
    review?.user?.nickName && (review?.feedback?.length > 0 || (review?.userComments !== null && review?.userComments.trim() !== ''))
  ));

  return sanitizedReviews;
}

export const sanitizeRatingsSummary = (ratingsSummaryData: RatingSummaryQueryInterface) => {
  if (
    !ratingsSummaryData ||
    ratingsSummaryData?.rating_avg === undefined ||
    ratingsSummaryData.rating_count === undefined ||
    ratingsSummaryData.top_feedback === undefined
  ) {
    return {
      avgRating: 0,
      ratingCount: 0,
      feedbacks: [],
    };
  }

  return {
    avgRating: ratingsSummaryData.rating_avg,
    ratingCount: ratingsSummaryData.rating_count,
    feedbacks: ratingsSummaryData.top_feedback,
  };
};